export default function isNumber(value) {
    return typeof value === "number";
}


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@telerik/kendo-intl/dist/es/common/is-number.js
// module id = ../../../../@telerik/kendo-intl/dist/es/common/is-number.js
// module chunks = vendor